import { Navigate } from "react-router-dom";

export const convertirFecha = (fecha) => {
  if (fecha == undefined) {
    return "//";
  }
  fecha = fecha.toString();

  let dia = fecha.substring(6, 8);
  let mes = fecha.substring(4, 6);
  let anio = fecha.substring(0, 4);

  return dia + "/" + mes + "/" + anio;
};

export const convertirFechaInputFecha = (fecha) => {
  if (fecha == undefined) {
    return "";
  }
  let fechas = fecha.split("/");

  let dia = fechas[0];
  let mes = fechas[1];
  let anio = fechas[2];

  let fechaParse =
    anio +
    "-" +
    (mes.length == 1 ? "0" + mes : mes) +
    "-" +
    (dia.length == 1 ? "0" + dia : dia);

  return fechaParse;
};
export const convertirFechaInputMonth = (fecha) => {
  let year = fecha.getFullYear();
  let month = fecha.getMonth() + 1;

  let fechaParse = year + "-" + (month < 10 ? "0" + month : month);
  return fechaParse;
};

export const convertirHora = (hora) => {
  if (!hora) {
    return "";
  }
  hora = hora.toString();
  let horaParse = hora.substring(0, 2) + ":" + hora.substring(2, 4);
  return horaParse;
};
export const textoTitulo = (texto) => {
  let textoedit = texto.toString();
  return textoedit.charAt(0).toUpperCase() + texto.substring(1, texto.length);
};

export const tamanioGrafica = (menuLateral = false) => {
  //Menú lateral indica si la gráfica no ocupa el 100% de la página, si no que también hay otra columna con información a la izquierda

  //Función para establecer el alto de la gráfica según el ancho del dispositivo

  if (menuLateral) {
    if (window.innerWidth <= 346) return 300;
    else if (window.innerWidth <= 425) return 280;
    else if (window.innerWidth <= 768) return 270;
    else if (window.innerWidth <= 1024) return 350;
    else if (window.innerWidth <= 1440) return 250;
    else if (window.innerWidth > 1440) return 150;
  } else {
    if (window.innerWidth <= 320) return 300;
    else if (window.innerWidth <= 425) return 250;
    else if (window.innerWidth <= 768) return 175;
    else if (window.innerWidth <= 1024) return 185;
    else if (window.innerWidth <= 1440) return 130;
    else if (window.innerWidth > 1440) return 95;
  }
};

export const tamanioGraficaLecturas = () => {
  //Función para establecer el alto de la gráfica de la vista gráficas lecturas, según el ancho del dispositivo

  if (window.innerWidth <= 320) return 250;
  else if (window.innerWidth <= 425) return 250;
  else if (window.innerWidth <= 768) return 185;
  else if (window.innerWidth <= 1024) return 195;
  else if (window.innerWidth <= 1440) return 100;
  else if (window.innerWidth > 1440) return 85;
};

//Redirigir al usuario al iniciar sesion o al intentar acceder al path '/' (depende de los roles del usuario)
export const redirigirSegunUser = (user) => {
  if (user?.roles[0] == "Cliente") {
    return <Navigate to={"/informacioncliente/user"} />;
  } else if (user?.roles[0] == "Admin" || user?.roles[0] == "Superadmin") {
    return <Navigate to={"/listadoInversores"} />;
  } else if (user?.roles[0] == "Facturacion") {
    return <Navigate to={"/facturasemitidas"} />;
  } else if (!user) {
    return <Navigate to={"/"} />;
  }
};

export const convertirFechaLetra = (fecha) => {
  if (fecha == undefined) {
    return "//";
  }
  let dia = fecha.substring(6, 8);
  let mes = fecha.substring(4, 6);
  let anio = fecha.substring(0, 4);

  let fechaformat = new Date(anio + "-" + mes + "-" + dia);
  let opciones = { day: "2-digit", month: "long", year: "numeric" };
  return fechaformat.toLocaleDateString("es-ES", opciones);
};

export const obtenerNombreHuertaId = (id) => {
  switch (id) {
    case 1:
      return "Tabernas";
    case 2:
      return "Iniesta";
    case 3:
      return "V. de la Jara";
    case 4:
      return "Villanueva Mesia";
    case 5:
      return "Albox";
    case 6:
      return "SSEE";
    case 7:
      return "Martos";
    case 8:
      return "Petroprix";
  }
};

export const abrirDropdown = (user) => {
  if (user?.roles[0] == "Superadmin" || user?.roles[0] == "Admin") {
    return "2";
  } else if (user?.roles[0] == "Facturacion") {
    return "5";
  } else if (user?.roles[0] == "Cliente") {
    return "1";
  }
};

export const convertirFechaDDMM = (fecha) => {
  if (fecha == 0) {
    return fecha;
  }

  fecha = fecha.toString();
  let dia = fecha.substring(6, 8);
  let mes = fecha.substring(4, 6);

  return dia + "/" + mes;
};

export const convertB64ToCSV = (b64, name) => {
  var link = document.createElement("a");
  link.download = name + ".xlsx";
  link.href = "data:application/octet-stream;base64," + b64;
  document.body.appendChild(link);

  link.click();
};
